export default {"src":"/_next/static/media/close.e39cdc90.svg","height":24,"width":24};